module.exports = __webpack_public_path__ + "img/add-page.66e029f4.svg";